import React from "react";
import { View, Image, Platform, StyleSheet, Pressable } from "react-native";
import {
  ApplicationStepperTickIcon,
  BG_STYLES,
  COMMON_STYLES,
  CrossIcon,
} from "@dehaat/dds";
import { TICK } from "../assests/images";

interface SuccessScreenProps {
  imageUri: string | null;
  handleTickPress: () => void;
  handleClose: () => void;
}

const SuccessScreen = ({
  imageUri,
  handleClose,
  handleTickPress,
}: SuccessScreenProps) => {
  return (
    <View style={[COMMON_STYLES.flex1, BG_STYLES.bgBlack]}>
      <Image
        source={{ uri: imageUri ? imageUri : ""}}
        style={[
          COMMON_STYLES.fullHeight,
          COMMON_STYLES.fullWidth,
          styles.backgroundImage,
        ]}
        resizeMode="cover"
      />

      <Pressable
        style={[COMMON_STYLES.absolute, styles.closeButton]}
        onPress={handleClose}
      >
        <CrossIcon width={30} height={30} strokeColor="white" />
      </Pressable>

      <Pressable
        style={[
          COMMON_STYLES.justifyCenter,
          COMMON_STYLES.alignItemsCenter,
          COMMON_STYLES.fullWidth,
          COMMON_STYLES.absolute,
          BG_STYLES.bgBlack,
          { bottom: 0, height: 120 },
        ]}
        onPress={handleTickPress}
      >
        <Image source={TICK} style={{ width: 64, height: 64 }} />
      </Pressable>
    </View>
  );
};

export default SuccessScreen;

const styles = StyleSheet.create({
  backgroundImage: {
    ...StyleSheet.absoluteFillObject,
  },
  closeButton: {
    top: Platform.OS === "android" ? 24 : 48,
    left: 16,
    zIndex: 10,
  },
});
